<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner"></fab-loading-spinner>

<div class="d-flex justify-content-between">
  <h1 mat-dialog-title>Edit Propulsion Scenario</h1>
  <div class="actions-container default-padding">
    <button mat-stroked-button id="cancel-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="submit-button" (click)="onSubmit()"
            [disabled]="!propulsionScenarioForm.valid">
      Submit
    </button>
  </div>
</div>

<div mat-dialog-content style="padding-top: unset; max-height:70vh">
  <form class="d-flex flex-column gap-8" [formGroup]="propulsionScenarioForm">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Enter Scenario</mat-label>
      <input matInput maxlength="100" id="scenario-input" formControlName="updatedPropulsionScenarioName"
             [(ngModel)]="propulsionScenario.propulsionScenarioName"
             value="{{ propulsionScenario.propulsionScenarioName }}"/>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Enter Scenario Assumption</mat-label>
      <textarea formControlName="updatedPropulsionScenarioAssumption" matInput rows="2" maxlength="150"
                id="scenario-assumption-input"
                [(ngModel)]="propulsionScenario.propulsionScenarioAssumption"
                value="{{ propulsionScenario.propulsionScenarioAssumption }}">
    </textarea>
    </mat-form-field>
    <div class="radio-button-group justify-content-center" *ngIf="isAdmin">
      <div id="del-lock-container" class="default-margin">
        <mat-label>Delete Lock:</mat-label>
        <mat-radio-group aria-label="Select an option" class="radio-group" formControlName="updatedIsDeleteLocked">
          <div *ngIf="propulsionScenario.isDeleteLocked === true; then selectDeleteLock else selectDeleteUnlock">
          </div>
          <ng-template #selectDeleteLock>
            <div>
              <mat-radio-button checked value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button value=false>OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectDeleteUnlock>
            <div>
              <mat-radio-button value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value=false>OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>
      <div id="edit-lock-container" class="default-margin">
        <mat-label>Edit Lock:</mat-label>
        <mat-radio-group aria-label="Select an option" class="radio-group" formControlName="updatedIsEditLocked">
          <div *ngIf="propulsionScenario.isEditLocked === true; then selectEditLock else selectEditUnlock">
          </div>
          <ng-template #selectEditLock>
            <div>
              <mat-radio-button checked value="true">ON</mat-radio-button>
              <br/>
              <mat-radio-button value="false">OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectEditUnlock>
            <div>
              <mat-radio-button value="true">ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value="false">OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>
      <div id="hidden-container" class="default-margin">
        <mat-label>Hide Scenario:</mat-label>
        <mat-radio-group aria-label="Select an option" class="radio-group justify-content-center"
                         formControlName="updatedIsHiddenLocked">
          <div *ngIf="propulsionScenario.isHidden === true; then selectHiddenLock else selectHiddenUnlock">
          </div>
          <ng-template #selectHiddenLock>
            <div>
              <mat-radio-button checked value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button value=false>OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectHiddenUnlock>
            <div>
              <mat-radio-button value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value=false>OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>
    </div>
  </form>

</div>
